'use client'
import { useCallback, useRef } from 'react'

export function useSearchOutcomes() {
  const lastOutcome = useRef<string | null>(null)
  const recordOutcome = useCallback((query: string, count: number, constraints: unknown = []) => {
    // Input remains in browser memory only, to deduplicate completed renders.
    const key = JSON.stringify([query, count, constraints])
    if (lastOutcome.current === key) return
    lastOutcome.current = key
    void import('@/lib/search/record-outcome').then(({ recordSearchOutcome }) => {
      recordSearchOutcome(query, count, constraints)
    })
  }, [])
  const recordSelection = useCallback((query: string, count: number, destination: string, constraints: unknown = []) => {
    void import('@/lib/search/record-outcome').then(({ recordSearchSelection }) => {
      recordSearchSelection(query, count, destination, constraints)
    })
  }, [])
  return { recordOutcome, recordSelection }
}
